import mapboxgl from "mapbox-gl";
import { renderToString } from "react-dom/server";
import { Dispatch, MutableRefObject } from "react";
import { IWaterSystemWCoordinates } from "../../../../../types";
import { Theme } from '@mui/material'
import {  getViolationColor } from "../../../../../utils/waterSystemHelper";
import { UtilityDetailActions } from "../../../../../store/utilityDetails";
import { WaterSystemsActions } from "../../../../../store/waterSystems";
import { AddressActions, IAddress } from "../../../../../store/Address";
import { AddressPinIcon } from "../../../../icons/AddressPinIcon";
import { PublicMarkerPinIcon } from "../../../../icons/PublicMarkerPinIcon";
import { MapActions } from '../../../../../store/Map'


export const addMarkers = (
  mapRef: React.RefObject<mapboxgl.Map>, 
  coordinates: IWaterSystemWCoordinates[],
  markersRef: MutableRefObject<mapboxgl.Marker[]>, 
  theme: Theme,
  dispatch: Dispatch<any>,
  selectedAddress: IAddress | null,
  isMobile: boolean = false
): void => {

  const map = mapRef.current;
  if (!map) {
    console.warn("Map reference is not initialized.");
    return;
  }

  removeMarkers(markersRef);
  const matches = coordinates.reduce((acc, curr)=>{
      const key = JSON.stringify(curr.COORDINATES)
    if(!acc[key]){acc[key] = []}
    acc[key].push(curr)
    return acc
  },{})

  const groupedMarkers = Object.entries(matches).filter(i=>(i[1] as any).length > 1)

  //0.0000009
  coordinates.forEach((coordinate: IWaterSystemWCoordinates) => {
    const { PWSID, COORDINATES, VIOLATIONS_COUNT, _id } = coordinate
    if (COORDINATES?.location) {
      let { lat, lng } = COORDINATES.location;
      const key =JSON.stringify(COORDINATES)
      const exists = groupedMarkers.find(i=>i[0] === key)

      if(exists){
        const arr = exists[1] as any
        const idx = arr.findIndex(i=>i._id === _id )
        const x = COORDINATES.location.lat + parseFloat((0.0000027 * idx).toFixed(7))
        const y = COORDINATES.location.lng + parseFloat((0.0000027 * idx).toFixed(7))
        lat = parseFloat(x.toFixed(7))
        lng = parseFloat(y.toFixed(7))
      }

      const color = getViolationColor(VIOLATIONS_COUNT, theme);
      //const pinColor = getPinColor(VIOLATIONS_COUNT, theme);
  
      const customMarkerHtml = renderToString(
        <PublicMarkerPinIcon fillColor={color} />
      );

      const customMarkerElement = document.createElement("div");
      customMarkerElement.innerHTML = customMarkerHtml;
      customMarkerElement.style.width = "24px";
      customMarkerElement.style.height = "24px";
      customMarkerElement.style.cursor = "pointer";

      customMarkerElement.addEventListener('mouseenter', () => {
        const markerPosition = map.project([lng, lat]);
        dispatch(MapActions.setPopupDetail({
          position: { x: markerPosition.x, y: markerPosition.y + 20 },
          visible: true,
          details:coordinate,
          timeout: null,
          fillColor: color
        }))

      });

      customMarkerElement.addEventListener('mouseleave', () => {
        dispatch(MapActions.setPopupDetail({
          timeout: 500,
        }))

      });

      customMarkerElement.addEventListener("click", (e) => {
           e.stopPropagation();
           if(isMobile) {
             const markerPosition = map.project([lng, lat]);
             dispatch(MapActions.setPopupDetail({
               position: { x: markerPosition.x, y: markerPosition.y + 20 },
               visible: true,
               details: coordinate,
               timeout: 10000,
               fillColor: color
             }))
           } else {
             dispatch(UtilityDetailActions.openDrawer());
           }

           dispatch(WaterSystemsActions.setSelectedWaterSystem(PWSID))
      });

      const marker = new mapboxgl.Marker({ element: customMarkerElement })
        .setLngLat([lng, lat])
        .addTo(map);

      markersRef.current.push(marker);
    }
  });

  if (selectedAddress) {
    const { latitude, longitude } = selectedAddress;
    
    const addressMarkerHtml = renderToString(
    <AddressPinIcon fillColor={theme.palette.primary.main} />
    );

    const addressMarkerElement = document.createElement("div");
    addressMarkerElement.innerHTML = addressMarkerHtml;
    addressMarkerElement.style.width = "24px";
    addressMarkerElement.style.height = "24px";
    addressMarkerElement.style.cursor = "pointer";

    addressMarkerElement.addEventListener('mouseenter', () => {
      const markerPosition = map.project([longitude, latitude]);
      dispatch(MapActions.setPopupDetail({
        position: { x: markerPosition.x, y: markerPosition.y + 20 },
        visible: true,
        //details:selectedAddress,
        timeout: null,
        fillColor: theme.palette.primary.main
      }))


    });

    addressMarkerElement.addEventListener('mouseleave', () => {
      dispatch(MapActions.setPopupDetail({timeout: 500,}))
    });

    addressMarkerElement.addEventListener("click", (e) => {
      e.stopPropagation();
      dispatch(AddressActions.setIsAddressClicked(true))
    });

    const addressMarker = new mapboxgl.Marker({ element: addressMarkerElement })
      .setLngLat([longitude, latitude])
      .addTo(map);

    markersRef.current.push(addressMarker);
  }
};

export const removeMarkers = (markersRef) => {
  if (Array.isArray(markersRef.current)) {
    markersRef.current.forEach((marker) => marker.remove());
    markersRef.current = [];
  }
};